// TODO: maxliu move this file to owa-sxs-store when this package is removed
var PreviewPaneSelectionSource;
(function (PreviewPaneSelectionSource) {
    PreviewPaneSelectionSource[PreviewPaneSelectionSource["MailList"] = 0] = "MailList";
    PreviewPaneSelectionSource[PreviewPaneSelectionSource["ReadingPane"] = 1] = "ReadingPane";
    PreviewPaneSelectionSource[PreviewPaneSelectionSource["FilesHub"] = 2] = "FilesHub";
    PreviewPaneSelectionSource[PreviewPaneSelectionSource["PhotoHub"] = 3] = "PhotoHub";
    PreviewPaneSelectionSource[PreviewPaneSelectionSource["GroupFilesHub"] = 4] = "GroupFilesHub";
    PreviewPaneSelectionSource[PreviewPaneSelectionSource["ConversationAttachmentWell"] = 5] = "ConversationAttachmentWell";
    PreviewPaneSelectionSource[PreviewPaneSelectionSource["Deeplink"] = 6] = "Deeplink";
})(PreviewPaneSelectionSource || (PreviewPaneSelectionSource = {}));
export default PreviewPaneSelectionSource;
//# sourceMappingURL=PreviewPaneSelectionSource.js.map